import { useMutation, useQuery } from "react-query";
import * as devicesService from '../services/deviceService';
import { ListDto } from "../types/dto";

const blockDevice = async ({ id, reason }: { id: string, reason?: string }) => {
  return devicesService.blockDevice(id, reason);
}

const unblockDevice = async (id: string) => {
  return devicesService.unblockDevice(id);
}


// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

export const useGetDevices = (dto: ListDto & { blocked?: boolean }, options = {}) => {
  return useQuery({
    queryKey: ['devices', dto],
    queryFn: () => devicesService.getDevices(dto),
    ...options
  });
}

export const useGetUserDevices = (userId: string, options = {}) => {
  return useQuery({
    queryKey: ['user-devices', userId],
    queryFn: () => devicesService.getUserDevices(userId),
    ...options
  });
}

export const useBlockDevice = (onSuccess: any, onError: any) => {
  return useMutation(blockDevice, {
    onSuccess,
    onError
  });
}

export const useUnblockDevice = (onSuccess: any, onError: any) => {
  return useMutation(unblockDevice, {
    onSuccess,
    onError
  });
}
